module.exports = __webpack_public_path__ + "static/media/Inter-Light.0f0118fe.woff";